import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SharePointOnlineListLinkedService } from 'app/model/linkedservice/sharepoint-online-list.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';
import { GlobalVariables } from 'app/services/globals';
import { ValueAdapter } from '../value.adapter';
import { Credential, servicePrincipalCredentialTypes, sharePointOnlineAuthTypes } from 'shell-models-lib';
import { ReferenceAdapter } from '../reference.adapter';
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SharePointOnlineListLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                tenantId: '*',
                servicePrincipalId: '*',
                servicePrincipalKey: 'secret',
                siteUrl: '*',
                encryptedCredential: '*',
                credential: '*',
                servicePrincipalCredentialType: '*',
                servicePrincipalEmbeddedCert: 'secret',
                servicePrincipalEmbeddedCertPassword: 'secret',
            },
            parameters: '*'
        }
    }
})
export class SharePointOnlineListLinkedServiceAdapter extends LinkedServiceAdapter<SharePointOnlineListLinkedService> {
    protected supportFirstClassParameterExperience = true;

    // /**
    //  * Update AuthenticationType based on fetched credential type
    //  * @param model linked service model
    //  */
    // public async postToModel(model: SharePointOnlineListLinkedService): Promise<void> {
    //     let finalAuthType: string = model.authenticationType;
    //     if (model.credential) {
    //         const credType = model.credential.getType();

    //         if (credType === CredentialTypeOptions.ServicePrincipal) {
    //             finalAuthType = AuthenticationType.ServicePrincipal;
    //         } else if (credType === CredentialTypeOptions.UserAuth) {
    //             finalAuthType = AuthenticationType.UserAuth;
    //         }
    //     }
    //     model.authenticationType = finalAuthType;
    // }

    protected modelConstructor(): new () => SharePointOnlineListLinkedService {
        return SharePointOnlineListLinkedService;
    }

    protected model(): IModel {
        return SharePointOnlineListLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SharePointOnlineListLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SharePointOnlineListLinkedService;

        let servicePrincipalId;
        let servicePrincipalKey;
        let servicePrincipalCredentialType;
        let servicePrincipalEmbeddedCert: string | Model.SecretBase;
        let servicePrincipalEmbeddedCertPassword: string | Model.SecretBase;
        let credential;
        const siteUrl = this.valueToResource(linkedService, SharePointOnlineListLinkedService.SITE_URL);
        const tenantId = this.valueToResource(linkedService, SharePointOnlineListLinkedService.TENANTID_ID);

        if (GlobalVariables.enableConnectorUserAuthCred) {
            if (linkedService.authenticationType === sharePointOnlineAuthTypes.ServicePrincipal) {
                servicePrincipalId = this.valueToResource(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_ID);
                servicePrincipalCredentialType = !linkedService.isOldServicePrincipalResource ? linkedService.servicePrincipalCredentialType : undefined;
                if (servicePrincipalCredentialType === servicePrincipalCredentialTypes.ServicePrincipalCert) {
                    servicePrincipalEmbeddedCert = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_EMBEDDED_CERT, this.context);
                    servicePrincipalEmbeddedCertPassword = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD, this.context);
                } else {
                    servicePrincipalKey = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_KEY, this.context);
                }

            } else if (linkedService.authenticationType === sharePointOnlineAuthTypes.UserAuth) {
                credential = linkedService.credential
                    ? ReferenceAdapter.toResource(linkedService.credential, this.context) as Model.CredentialReference
                    : undefined;
            }
        } else {
            servicePrincipalId = this.valueToResource(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_ID);
            servicePrincipalCredentialType = !linkedService.isOldServicePrincipalResource ? linkedService.servicePrincipalCredentialType : undefined;
            if (servicePrincipalCredentialType === servicePrincipalCredentialTypes.ServicePrincipalCert) {
                servicePrincipalEmbeddedCert = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_EMBEDDED_CERT, this.context);
                servicePrincipalEmbeddedCertPassword = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD, this.context);
            } else {
                servicePrincipalKey = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_KEY, this.context);
            }
        }

        properties.type = Metamodel.modelFor(SharePointOnlineListLinkedService).name;
        properties.typeProperties = {
            siteUrl,
            tenantId,
            servicePrincipalId,
            servicePrincipalKey,
            servicePrincipalCredentialType,
            servicePrincipalEmbeddedCert,
            servicePrincipalEmbeddedCertPassword,
            credential
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(modelLinkedServiceResource: Model.LinkedServiceResource, linkedService: SharePointOnlineListLinkedService): Promise<SharePointOnlineListLinkedService> {
        const prop = modelLinkedServiceResource.properties as Model.SharePointOnlineListLinkedService;
        const typeProperties = prop.typeProperties;

        ValueAdapter.toModel(linkedService, SharePointOnlineListLinkedService.SITE_URL, typeProperties.siteUrl);
        ValueAdapter.toModel(linkedService, SharePointOnlineListLinkedService.TENANTID_ID, typeProperties.tenantId);
        if (GlobalVariables.enableConnectorUserAuthCred) {
            if (typeProperties.servicePrincipalId) {
                linkedService.authenticationType = sharePointOnlineAuthTypes.ServicePrincipal;
                this._processSPToModel(linkedService, typeProperties);
            } else if (typeProperties.credential) {
                linkedService.authenticationType = sharePointOnlineAuthTypes.UserAuth;
                linkedService.credential = ReferenceAdapter.toProxyModel(Metamodel.modelFor(Credential), typeProperties.credential, this.context);
            }
        } else {
            this._processSPToModel(linkedService, typeProperties);
        }
        return linkedService;
    }

    private _processSPToModel(linkedService: SharePointOnlineListLinkedService, typeProperties: Model.SharePointOnlineListLinkedServiceTypeProperties) {
        ValueAdapter.toModel(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_ID, typeProperties.servicePrincipalId);
        linkedService.servicePrincipalCredentialType = typeProperties.servicePrincipalCredentialType as keyof typeof servicePrincipalCredentialTypes;
        linkedService.isOldServicePrincipalResource = !typeProperties.servicePrincipalCredentialType;
        linkedService.isExistingServicePrincipalKeyResource = linkedService.servicePrincipalCredentialType === servicePrincipalCredentialTypes.ServicePrincipalKey;
        if (linkedService.servicePrincipalCredentialType === servicePrincipalCredentialTypes.ServicePrincipalCert) {
            parameterizableSecretBaseToModel(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_EMBEDDED_CERT, typeProperties.servicePrincipalEmbeddedCert, this.context)
            parameterizableSecretBaseToModel(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD, typeProperties.servicePrincipalEmbeddedCertPassword, this.context)
        } else {
            parameterizableSecretBaseToModel(linkedService, SharePointOnlineListLinkedService.SERVICE_PRINCIPAL_KEY, typeProperties.servicePrincipalKey, this.context);
        }
    }
}
